import * as React from 'react';
import { encodeQr, qrPath } from './qr.ts';

/** A QR Code of `value`, drawn as one SVG path: dark modules on white, with the standard quiet zone. */
export function QrCode({
  value,
  size = 192,
  testId,
  label,
}: {
  value: string;
  size?: number;
  testId?: string;
  label: string;
}) {
  const modules = React.useMemo(() => encodeQr(value, 'M'), [value]);
  const n = modules.length + 8;
  return (
    <svg
      role="img"
      aria-label={label}
      data-testid={testId}
      data-modules={modules.length}
      width={size}
      height={size}
      viewBox={`0 0 ${n} ${n}`}
      shapeRendering="crispEdges"
      className="rounded-[6px]"
    >
      <rect width={n} height={n} fill="#ffffff" />
      <path d={qrPath(modules)} fill="#000000" />
    </svg>
  );
}
